module.exports = __webpack_public_path__ + "img/40-green.b2b07fdd.svg";